import Button from '@gaia/components/Button';
import type {ControlPointPopupProps} from '@map/Map/useControlPointPopup';
import PopupCloseButton from '@map/popups/PopupCloseButton';

export function AreaPointPopup({
    interaction,
    onInteractionChange,
    selection: {localId},
    setSelections,
}: ControlPointPopupProps & {selection: WaypointSelectionState}) {
    if (interaction.type !== 'editingArea' || !interaction.area) return null;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '-5px', // override default margin on mapbox GL JS popup
            }}
        >
            <PopupCloseButton onClick={() => setSelections([])} />
            <Button
                appearance='destruct'
                iconName='delete'
                onClick={() => {
                    onInteractionChange({
                        ...interaction,
                        type: 'editingArea',
                        subtype: 'removingPoint',
                        pointLocalId: localId,
                    });
                }}
                size='small'
            >
                Delete Point
            </Button>
        </div>
    );
}
